import { Input } from 'antd';
import Link from 'antd/es/typography/Link';
import { SearchOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingBasket } from "@fortawesome/free-solid-svg-icons";

const Header = ({ collapsed, toggleNavbar, onSearch, search }) => {


    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white position-relative">
            <Link className="navbar-brand" to="/">
                <h3 className='fw-bold'><span className='logoColor'>M</span>OBOO<span className='logoColor'>M</span></h3>
            </Link>

            <button className="navbar-toggler" onClick={toggleNavbar} type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className={`collapse navbar-collapse justify-content-end align-ietms-center  ${collapsed ? '' : 'show'}`} id="navbarNav">
                <ul className="navbar-nav">
                    <li className='nav-item'>
                        <Input size='large' allowClear style={{ width: "350px" }} onChange={onSearch} className='search'
                         suffix={!search ? (<SearchOutlined className="site-form-item-icon pointer" tabIndex={0} onClick={onSearch} />) : null}
                        />
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" >Store</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link">Account</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" >Wishlist</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link text-black">Basket &nbsp;<FontAwesomeIcon icon={faShoppingBasket} />
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
    )
}

export default Header;